import { createSelector } from 'reselect';
import { RootState } from '../../reducers';
import { isAuthenticated } from '../../selectors/app';
import components from '../../selectors/components';

const root = (state: RootState) => components(state).fullRegistration;

export const timeouts = createSelector(root, (result) => ({
  codeSource: result.codeSource,
  smsCodeTimeout: result.smsCodeTimeout,
  emailCodeTimeout: result.emailCodeTimeout,
}));

export const sessionId = createSelector(root, ({ sessionId }) => sessionId);

export const personalData = createSelector(root, (result) => ({
  email: result.email,
  phone: result.phone,
}));

export const fullRegistartionInfo = createSelector(root, isAuthenticated, (root, auth) => ({
  step: root.step,
  isAuthenticated: auth.isAuthenticated,
  userName: root.firstName,
}));

export default root;
